export default "/_next/static/media/tutorial-03.d0fa71da1206fbd8c194cd59582f7a99.jpg";